module.exports = __webpack_public_path__ + "95283bca9c0109a968e0c7703d74cbb0.svg";